import NavigationListItem from '@components/AppNavigation/NavigationListItem';
import NavigationMenuListSubHeader from '@components/AppNavigation/NavigationMenuListSubHeader';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { APP_ROUTES } from 'constants/routes';
import React, { FC } from 'react';

interface INavigationMenuProps {
	isOpen: boolean;
	onClick: (route: string) => void;
}

const NavigationMenu: FC<INavigationMenuProps> = (props) => {
	const { isOpen } = props;

	return (
		<List
			data-testid="navigation-menu-list"
			aria-label="menu"
			role="navigation"
			component="nav"
		>
			<ul>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.home}
					translation={intl.tr('pages.home.title')}
					Icon={HomeOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.gettingStarted}
					translation={intl.tr('pages.gettingStarted.title')}
					Icon={FlagOutlinedIcon}
					sx={{ pb: 2 }}
				/>
				<NavigationMenuListSubHeader isOpen={isOpen}>
					<>{intl.tr('pages.build.title')}</>
				</NavigationMenuListSubHeader>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.authMethodsOTP}
					translation={intl.tr('pages.authenticationMethods.title')}
					Icon={HowToRegOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.flows}
					translation={intl.tr('pages.flows.title')}
					Icon={AccountTreeOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.flowStyleEditor}
					translation={intl.tr('pages.flowStyleEditor.title')}
					Icon={BrushOutlinedIcon}
				/>
				<Box py={1} component="li" />
				<NavigationMenuListSubHeader isOpen={isOpen}>
					<>{intl.tr('pages.manage.title')}</>
				</NavigationMenuListSubHeader>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.users}
					translation={intl.tr('pages.users.title')}
					Icon={PeopleAltOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.accessKeys}
					translation={intl.tr('pages.accessKeys.title')}
					Icon={VpnKeyOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.tenants}
					translation={intl.tr('pages.tenants.title')}
					Icon={HolidayVillageOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.authorization}
					translation={intl.tr('pages.authorization.title')}
					Icon={LockOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.audits}
					translation={intl.tr('pages.audits.title')}
					Icon={FormatListBulletedIcon}
				/>
				<Box py={1} component="li" />
				<NavigationMenuListSubHeader isOpen={isOpen}>
					<>{intl.tr('pages.settings.title')}</>
				</NavigationMenuListSubHeader>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.projectSettings}
					translation={intl.tr('pages.projectSettings.title')}
					Icon={SourceOutlinedIcon}
				/>
				<NavigationListItem
					{...props}
					pageRoute={APP_ROUTES.company}
					translation={intl.tr('pages.company.title')}
					Icon={BusinessOutlinedIcon}
				/>
			</ul>
		</List>
	);
};

export default NavigationMenu;
